import React, {useEffect, useState, useContext} from 'react';
import CheckField from '../../../../components/CheckField2/CheckField'
// import Required from "../../Required";
// import Checkbox from "../../Checkbox";
// import { Field } from "formik";
// import RadioButtonGroup from "../../RadioButtonGroup";
// import RadioButton from "../../RadioButton";
import './styles.scss'
// import infoCircle from '../../styles/assets/info-circle.png'
// import Popover from '../../../../../formik/refactorOut/components/Popper/Popover.js'
// import { popoverLocation } from "../../../../../config/Configuration";
import {SectionHeader} from '../../../../components/sectionHeader/sectionHeader'
import TextField from '../../../../components/TextField/TextField'
// import TextField_NoLogic from '../../TextField/TextField_NoLogic'
import TextField_Custom from '../../../../components/TextField/TextField_Custom'
import ErrorBar from '../../../../components/ErrorBar'
import { ConfigContext } from '../../DynamicForm/DynamicForm'

const Facilities_7168 = ({ formik, template, config, orgId, formColor }) => {
    
    // state values
    const [facilities, setFacilities] = useState([])
    const [validation, setValidation] = useState({state: false, message: ''})
    const [facilitiesError, setFacilitiesError] = useState({state: false, message: ''})
    const [selectedItems, setSelectedItems] = useState(['NYC Health & Hospitals'])
    const [ITRMessage, setITRMessage] = useState("As you select the facilities below, this text will update automatically.  If no facilities are selected, this box will be left blank on the final form.  Please note, COVID test results may take 5-7 days.")

    // sets up context
    let appContext = useContext(ConfigContext)
    const {dbFormSpec, validationValues } = useContext(ConfigContext);
    appContext.localValues = {};
    appContext.localValues.facilityList = facilities;
    
    // when formik facility list is changed, update local facilities array
    useEffect(() => {
        let facilitiesArray = []
        Object.values(formik.values.facilityList).forEach((facility, index) => {
            if (facility !== '') {
                let facilityArray = []
                Object.values(facility).forEach((property, index) => {
                    property && facilityArray.push(property)
                })
                facilitiesArray.push(`${facilityArray.join(', ')}`)
            }
        })
        setFacilities(facilitiesArray)
    }, [formik.values.facilityList])
    
    // when there is an error on a single facility, set an overall error on facilities component
    useEffect(()=>{
        appContext.localError = facilitiesError.state
        console.log(appContext.localError)
        console.log("facilitiesError.state", facilitiesError.state)
        console.log("appContext.localError", appContext)
    }, [facilitiesError])
    
    // when formik facility list is changed, update facilityOrPhysician accordingly
    useEffect(()=>{
        if (Object.values(formik.values.facilityList).every((value)=>{ return value.length == 0 })) {
            formik.setFieldValue('facilityOrPhysician', "")
        }
        else {
            formik.setFieldValue('facilityOrPhysician', "on")
        }
    }, [formik.values.facilityList])
    
    useEffect(()=>{
        formik.setFieldValue('facilityList', ["NYC Health & Hospitals"])
    }, [])
    
    useEffect(()=>{
        formik.values.facilityList.length > 1 ? setSelectedItems(formik.values.facilityList.join(', ')) : setSelectedItems("As you select the facilities below, this text will update automatically.  If no facilities are selected, this box will be left blank on the final form.  Please note, COVID test results may take 5-7 days.")
    }, [formik.values.facilityList])

    return (
        <div id='medicalFacilitiesRequested' className='form-section'>
                    <SectionHeader sectionTitle={'Medical Facilities Section'} styles={{ color: dbFormSpec.color }} />

                    
                    <div id='facility-disclosure-container'>
                        <div className='facility-selection' id='facilityOrPhysician'>
                            {formik.errors.facilityOrPhysician && formik.touched.facilityOrPhysician && <ErrorBar message={formik.errors.facilityOrPhysician} />}
                            {(!formik.errors.facilityOrPhysician && formik.values.inputDisclosePhysicians && formik.errors.inputPhysicianNames && formik.touched.inputPhysicianNames) && <ErrorBar message={formik.errors.inputPhysicianNames} />}
                            <label className='section-instruction subtitle1'> {`${"Select the parties from which you'd like to receive the requested medical information"}`}</label>
                            <div style={{marginBottom: 20}}>{'I authorize'}</div>
                            <CheckField checkboxType={'facility'} formik={formik} formValue={'key'} checkItemLabel={'NYC Health + Hospitals'} trueFormSpec={dbFormSpec} decorative={true}/>
                            <div style={{marginTop: 20}}>Additional Locations</div> 
                            <div style={{height:100, background: 'rgb(240, 240, 240)', padding: 10, marginTop: 10, marginBottom: 20}}>{selectedItems}</div>
                            <div className='facilities-physicians'>

                                {
                                    // renderAdvancedFacilityList ? <FacilityAdvancedList dbFormSpec={dbFormSpec} formik={formik} /> :
                                    //  //   tripartiteOrg ? <TripartiteFacilities orgId={orgId} formik={formik} template={template} config={validationValues} dbFormSpec={dbFormSpec} /> :
                                    //     renderFacilityRadiogroup ? <FacilityRadioList dbFormSpec={dbFormSpec} formik={formik} /> :

                                                <div id='ordinary-facilities' className='form-fields' style={{}}>
                                                    {dbFormSpec.release.facilities.map((item, index) => {
                                                        return (
                                                            (!item.type) && (item.key !== 'otherFac') && (!item.value.includes('LTC')) && (!item.value.includes('LTACH')) && (!item.value.includes('Outpatient')) &&
                                                            <>
                                                                <div className='facility-item' key={index}><CheckField checkboxType={'facility'} formik={formik} formValue={item.key} checkItemLabel={item.value} trueFormSpec={dbFormSpec} tooltip={item.tooltip} /></div>
                                                            </>
                                                        )
                                                    })
                                                    }
                                                    {/* <CheckField checkboxType={'facility'} formik={formik} formValue={'key'} checkItemLabel={'Outpatient Clinic locations'} trueFormSpec={dbFormSpec} /> */}
                                                </div>}
                                                    <div style={{marginTop: 20, marginBottom: 10}}>Outpatient Clinic locations</div> 
                                                    <div style={{display: 'flex', flexWrap: 'wrap'}}>
                                                        {dbFormSpec.release.facilities.map((item, index) => {
                                                            return (
                                                                (!item.type) && (item.key !== 'otherFac') && (item.value.includes('Outpatient')) &&
                                                                <>
                                                                    <div className='facility-item' key={index}><CheckField checkboxType={'facility'} formik={formik} formValue={item.key} checkItemLabel={item.value} trueFormSpec={dbFormSpec} tooltip={item.tooltip}/></div>
                                                                </>
                                                            )
                                                        })}
                                                    </div>
                                                    {/* <CheckField checkboxType={'facility'} formik={formik} formValue={'key'} checkItemLabel={'Long-Term Care locations'} trueFormSpec={dbFormSpec} /> */}
                                                    <div style={{marginTop: 20, marginBottom: 10}}>Long-Term Care locations</div> 
                                                    <div style={{display: 'flex', flexWrap: 'wrap'}}>
                                                    {dbFormSpec.release.facilities.map((item, index) => {
                                                        return (
                                                            (!item.type) && (item.key !== 'otherFac') && (item.value.includes('LTC') || item.value.includes('LTACH')) &&
                                                            <>
                                                                <div className='facility-item' key={index}><CheckField checkboxType={'facility'} formik={formik} formValue={item.key} checkItemLabel={item.value} trueFormSpec={dbFormSpec} tooltip={item.tooltip}/></div>
                                                            </>
                                                        )
                                                    })}
                                                    </div>
                                                    {/* <div style={{ display: 'block', width: '100%', marginTop: 10 }}><TextField formik={formik} fieldId={'facilityOther'} cssField={'fname-field'} label={`${'sdfkhdsfdskljf'}`} /></div> */}
                                <div id="CustomText">{dbFormSpec.AuthorizationToReleaseCustomText ? dbFormSpec.AuthorizationToReleaseCustomText : ""} </div>
                            </div>
                        </div>
                    </div>
                </div>
    )
}

export default Facilities_7168;


const DecorativeCheckbox = (props) => {
    
    return (
        <div className='decorative-checkbox'>
            <input type="checkbox" className='7227-checkbox checkbox' checked={props.checked} onChange={props.onChange} /> 
            <label className='decorative-checkbox-label' style={{...props.labelStyle, fontWeight:600}}>{props.label}</label>
        </div>
    )
}

const ThreeLevelFacilityForm = ({setFacilitiesError, set}) => {

    // state values
    const [error, setError] = useState({state: false, message: ''})
    const [enteredValues, setEnteredValues] = useState({
        facility_name: '',
        facility_address: '',
        facility_doctor: '',
    })

    // context values
    const {formik, setLocalError} = useContext(ConfigContext);
    
    // local variables
    const requiredFields = [enteredValues.facility_name, enteredValues.facility_address]
    
    // Sets error on this component, which is passed down to the individual fields
    // Sets the value of formik.values.facilityList every time enteredValues changes
    useEffect(()=>{
        requiredFields.some((value)=>{ return value.length > 0 }) && requiredFields.some((value)=>{ return value.length == 0 }) ? setError({state: true, message: 'blah'}) : setError({state: false, message: 'blah'})
        // if every property on enteredValues is empty...
        if (Object.values(enteredValues).every((value)=>{ return !value })) {
            formik.setFieldValue('facilityList', {...formik.values.facilityList, [set]: ""})
        } else {
            formik.setFieldValue('facilityList', {...formik.values.facilityList, [set]: enteredValues})
        }
    }, [enteredValues])
    
    // Sets error on parent component
    useEffect(()=>{
        console.log('COMPONENTERROR', error)
        error.state ? setFacilitiesError({state: true, message: error.message}) : setFacilitiesError({state: false, message: ''})
        error.state ? setLocalError(true) : setLocalError(false)
    }, [error])
    
    return (
        <div className="threelevelfacilityform">
            <label htmlFor="" className='label'>Facility {set}</label>
            <div className="input-fields">
                <TextField_Custom fieldId={'facility_name'} cssField={'css-field'} label={'Facility Name'} maxLength={100} variant={'7307_facility'} fieldIsRequired={true} stateProps={{setEnteredValues: setEnteredValues, enteredValues: enteredValues, error: error, setError: setError, errorMessage: 'Please provide a facility name'}}/>
                <TextField_Custom fieldId={'facility_address'} cssField={'css-field'} label={'Facility Address'} maxLength={100} variant={'7307_facility'} fieldIsRequired={true} stateProps={{setEnteredValues: setEnteredValues, enteredValues: enteredValues, error: error, setError: setError, errorMessage: 'Please provide a facility address'}}/>
                <TextField_Custom fieldId={'facility_doctor'} cssField={'css-field'} label={"Doctor's Name (Optional)"} maxLength={100} variant={'7307_facility'} fieldIsRequired={false} stateProps={{setEnteredValues: setEnteredValues, enteredValues: enteredValues, error: error, setError: setError}}/>
            </div>
        </div>
    )
    
    // what triggers an error on the field?
    // what is/are the error message(s)?
    // what happens when the field is focused?
    // what happens when the field is blurred?
    // what happens when the field is changed?
    // what are invalid values?
    // what happens when the field is changed to an invalid value?


}


